var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRcFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 27,
    viewBox: "0 0 47 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.28271,
    width: 44,
    height: 24,
    fill: "#F7F7F7",
    stroke: "#E75300",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.28271H24.6314C24.8634 6.28276 25.0859 6.37498 25.25 6.53909L28.4936 9.78271C28.6577 9.94677 28.75 10.1693 28.75 10.4013V18.5327C28.75 18.9968 28.5656 19.442 28.2374 19.7702C27.9092 20.0983 27.4641 20.2827 27 20.2827H20C19.5359 20.2827 19.0908 20.0983 18.7626 19.7702C18.4344 19.442 18.25 18.9968 18.25 18.5327V8.03271C18.25 7.56859 18.4344 7.12347 18.7626 6.79528C19.0908 6.46709 19.5359 6.28271 20 6.28271V6.28271ZM24.8125 7.59521V9.34521C24.8125 9.57728 24.9047 9.79984 25.0688 9.96393C25.2329 10.128 25.4554 10.2202 25.6875 10.2202H27.4375L24.8125 7.59521Z",
    fill: "#E75300"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcFront);
export default __webpack_public_path__ + "static/media/rc-front.f6b992943f2c3be827da4fe827aaf626.svg";
export { ForwardRef as ReactComponent };